import { SamsungPayButtonTypeEnumsObj } from "../enums/SamsungPayButtonTypeEnum";
import { SamsungPayButtonColorEnumsObj } from "../enums/SamsungPayButtonColorEnum";
/**
 * Samsung Pay button paramaters type to control content and appearance of the button.
 */
var SamsungPayButtonParams = /** @class */ (function () {
    function SamsungPayButtonParams() {
    }
    return SamsungPayButtonParams;
}());
export { SamsungPayButtonParams };
/** @internal */
export var validateButtonParams = function (samsungPayButtonParams) {
    var errorMessage = [];
    if (!samsungPayButtonParams) {
        errorMessage.push("samsungPayButtonParams not defined");
        return errorMessage;
    }
    if (samsungPayButtonParams.buttonLocale && samsungPayButtonParams.buttonLocale !== "en_GB") {
        errorMessage.push("buttonLocale not valid");
    }
    if (!samsungPayButtonParams.buttonColor) {
        errorMessage.push("buttonColor not defined");
    }
    else if (!Object.values(SamsungPayButtonColorEnumsObj).includes(samsungPayButtonParams.buttonColor)) {
        errorMessage.push("wrong buttonColor value");
    }
    if (!samsungPayButtonParams.buttonType) {
        errorMessage.push("buttonType not defined");
    }
    else if (!Object.values(SamsungPayButtonTypeEnumsObj).includes(samsungPayButtonParams.buttonType)) {
        errorMessage.push("wrong buttonType value");
    }
    if (samsungPayButtonParams.buttonOnClick !== undefined &&
        typeof samsungPayButtonParams.buttonOnClick !== "function") {
        errorMessage.push("buttonOnClick is not a function");
    }
    return errorMessage;
};
